/*LIBRARY*/
import { useEffect, useState } from "react";
import { connect } from "react-redux";

/*COMPONENT*/

/*REDUX*/
import { editFieldForm } from "../../App/actions/layerActions";

/*PICTURE*/

/*FUNCTION*/
import isEmpty from "../../App/validation/is-empty";

/*DATA*/
import dict from "../../Data/dict.json";

/*CONST*/

const EditTerm = ({
  field: propField,
  fields: propFields,
  geo_layer_id,
  auth,
  editFieldForm,
}) => {
  const [field, setField] = useState({});
  const [field_inside_term, setFieldInsideTerm] = useState({});
  const [fields, setFields] = useState([]);

  useEffect(() => {
    setField(propField);
    setFields(propFields);
  }, [propField, propFields]);

  const handle_add_term = () => {
    const term_array = field_inside_term.term_array;
    let updated_field = field;
    let uuid = field_inside_term.uuid;
    let term_array_origin = updated_field?.term ? updated_field.term : [];
    const term = {
      uuid,
      value: term_array,
    };
    term_array_origin.push(term);
    updated_field.term = term_array_origin;
    updated_field.term_mode = "and";
    const body = {
      geo_layer_id,
      field: updated_field,
    };
    editFieldForm(body);
  };

  const handle_change = (e) => {
    e.preventDefault();
    const target = e.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    if (["uuid_inside_term"].includes(name)) {
      const selected_field = value
        ? fields.filter((e) => e.uuid === value)[0]
        : fields[0];
      setFieldInsideTerm(selected_field);
    } else if (["term_mode"].includes(name)) {
      let updated_field = { ...field };
      updated_field.term_mode = value;
      const body = {
        geo_layer_id,
        field: updated_field,
      };
      editFieldForm(body);
    }
  };

  const handle_delete_term = (idx) => {
    let updated_field = { ...field };
    let term_array_origin = updated_field?.term ? updated_field.term : [];
    term_array_origin.splice(idx, 1);
    updated_field.term = term_array_origin;
    const body = {
      geo_layer_id,
      field: updated_field,
    };
    editFieldForm(body);
  };

  const on_remove_term = (name) => {
    let updated_field_inside_term = { ...field_inside_term };
    let term_array = updated_field_inside_term.term_array
      ? updated_field_inside_term.term_array
      : [];
    term_array = term_array.filter((v) => v !== name);
    updated_field_inside_term.term_array = term_array;
    setFieldInsideTerm(updated_field_inside_term);
  };

  const on_click_term = (name) => {
    let updated_field_inside_term = { ...field_inside_term };
    let term_array = updated_field_inside_term.term_array
      ? updated_field_inside_term.term_array
      : [];
    term_array.push(name);
    updated_field_inside_term.term_array = term_array;
    setFieldInsideTerm(updated_field_inside_term);
  };

  //local storage
  const language = localStorage?.language || auth.language;

  //local state

  //global props

  //content
  const term_mode = field?.term_mode ? field.term_mode : "and";
  const term = field?.term ? field.term : [];

  const fields_temp = fields.filter((e) => e.uuid !== field.uuid);
  const current_field_inside_term = !isEmpty(field_inside_term)
    ? field_inside_term
    : fields_temp[0];
  let array_templates_term = !isEmpty(field_inside_term)
    ? field_inside_term?.array_templates
    : [];
  array_templates_term = array_templates_term.map((e) => e.name);
  const term_array = !isEmpty(field_inside_term?.term_array)
    ? field_inside_term?.term_array
    : [];

  let content = null;

  const mode_array = [
    {
      name: dict["And"][language],
      value: "and",
    },
    {
      name: dict["Or"][language],
      value: "or",
    },
  ];

  content = (
    <>
      <section className="text_big margin_bottom">{field.name}</section>
      <section className="text_bold sub_color margin_bottom">
        Pertanyaan ini akan muncul hanya jika:
      </section>

      <section className="text_bold margin_bottom_extra">
        {term.length === 0 ? (
          <p>{dict["There are no conditions created yet"][language]}</p>
        ) : (
          <table className="table full_width">
            <thead>
              <tr>
                <th>{dict["Question"][language]}</th>
                <th>{dict["Answer"][language]}</th>
              </tr>
            </thead>
            <tbody>
              {term.map((t, idx) => {
                const field_item = fields.filter((f) => f.uuid === t.uuid)[0];

                return (
                  <tr key={idx}>
                    <td>
                      <p className="text_medium sub_color">
                        {field_item?.name
                          ? field_item.name
                          : `(${dict["Question has been deleted"][language]})`}
                      </p>

                      <button
                        onClick={() => handle_delete_term(idx)}
                        className="button_very_small"
                        id="deleteBright"
                      >
                        {dict["Delete"][language]}
                      </button>
                    </td>
                    <td>
                      {t?.value?.map((item, idx) => {
                        return (
                          <p
                            className="badge blue_container margin_right margin_bottom"
                            key={idx}
                          >
                            {item}
                          </p>
                        );
                      })}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </section>

      <div className="container background_grey_light outline_grey">
        <p className="text_bold margin_bottom">Penambahan syarat</p>
        <section>
          Mode:
          <select
            name="term_mode"
            id="term_mode"
            value={term_mode}
            onChange={handle_change}
            style={{ maxWidth: "100px", display: "inline-block" }}
          >
            {mode_array.map((mode, idx) => {
              return (
                <option value={mode.value} key={idx}>
                  {mode.name}
                </option>
              );
            })}
          </select>
        </section>

        <section className="two_container_equal">
          <div>
            <select
              name="uuid_inside_term"
              id="uuid_inside_term"
              value={
                current_field_inside_term?.uuid
                  ? current_field_inside_term.uuid
                  : fields[0]?.uuid
              }
              onChange={handle_change}
            >
              {fields_temp.map((e, idx) => {
                return (
                  <option value={e.uuid} key={idx}>
                    {e.name}
                  </option>
                );
              })}
            </select>
          </div>
          <div>
            {array_templates_term.length === 0 ? (
              <div>
                {
                  dict[
                    "There is no template for this question, first add template in edit menu"
                  ][language]
                }
              </div>
            ) : (
              array_templates_term.map((name, idx_c) => {
                return (
                  <main key={idx_c} style={{ marginBottom: "5px" }}>
                    {term_array.includes(name) ? (
                      <section
                        className="multi_check"
                        id="active_strong"
                        onClick={() => on_remove_term(name)}
                      >
                        ✓
                      </section>
                    ) : (
                      <section
                        className="multi_check"
                        id="not_active"
                        onClick={() => on_click_term(name)}
                      />
                    )}
                    <section htmlFor={name} style={{ display: "inline-block" }}>
                      {name}
                    </section>
                  </main>
                );
              })
            )}
          </div>
        </section>
        <section
          className="button_big background_black"
          onClick={handle_add_term}
        >
          {dict["Add condition"][language]}
        </section>
      </div>
    </>
  );
  return content;
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  geo_layer_id: state?.layer?.geo_layer_wo_geojson?.geo_layer?._id,
});

export default connect(mapStateToProps, {
  editFieldForm,
})(EditTerm);
